//# sourceMappingURL=list_users.mjs.map
/// <reference types="./list_users.d.mts" />
import * as $when from "../../../../altar/altar/when.mjs";
import * as $user_id from "../../../../data_types/data/auth/user_id.mjs";
import * as $remote from "../../../../data_types/data/remote.mjs";
import * as $user from "../../../../data_types/data/user.mjs";
import * as $colors from "../../../../ds/ds/colors.mjs";
import { palette } from "../../../../ds/ds/colors.mjs";
import * as $button from "../../../../ds/ds/components/button.mjs";
import * as $checkbox from "../../../../ds/ds/components/checkbox.mjs";
import * as $label from "../../../../ds/ds/components/label.mjs";
import * as $l from "../../../../ds/ds/components/layout.mjs";
import * as $modal from "../../../../ds/ds/components/modal.mjs";
import * as $pp from "../../../../ds/ds/components/profile_picture.mjs";
import * as $skeleton from "../../../../ds/ds/components/skeleton.mjs";
import * as $table from "../../../../ds/ds/components/table.mjs";
import * as $typo from "../../../../ds/ds/components/typography.mjs";
import * as $promise from "../../../../gleam_javascript/gleam/javascript/promise.mjs";
import * as $int from "../../../../gleam_stdlib/gleam/int.mjs";
import * as $list from "../../../../gleam_stdlib/gleam/list.mjs";
import * as $option from "../../../../gleam_stdlib/gleam/option.mjs";
import { None, Some } from "../../../../gleam_stdlib/gleam/option.mjs";
import * as $set from "../../../../gleam_stdlib/gleam/set.mjs";
import * as $redraw from "../../../../redraw/redraw.mjs";
import * as $a from "../../../../redraw_dom/redraw/dom/attribute.mjs";
import * as $e from "../../../../redraw_dom/redraw/dom/events.mjs";
import * as $h from "../../../../redraw_dom/redraw/dom/html.mjs";
import * as $function from "../../../../tiamat/tiamat/function.mjs";
import * as $user_effects from "../../../admin/effects/user.mjs";
import * as $store from "../../../data/store.mjs";
import { Ok, Error, toList, CustomType as $CustomType } from "../../../gleam.mjs";
import * as $common from "../../../view/common.mjs";

class BulkActionsProps extends $CustomType {
  constructor(selected, set_selected, org_id) {
    super();
    this.selected = selected;
    this.set_selected = set_selected;
    this.org_id = org_id;
  }
}

class AssignRolesConfirm extends $CustomType {
  constructor(role_ids) {
    super();
    this.role_ids = role_ids;
  }
}

class RemoveRolesConfirm extends $CustomType {
  constructor(role_ids) {
    super();
    this.role_ids = role_ids;
  }
}

function user_function(user) {
  let $ = user.function;
  if ($ instanceof Some) {
    let function$ = $[0];
    let function$1 = $user.function_to_string(function$);
    return $label.label(toList([$label.content(function$1)]));
  } else {
    return $label.label(toList([$label.content("None")]));
  }
}

function user_name(user) {
  let name = $a.style(
    toList([["font-weight", "500"], ["color", palette.text_body]]),
  );
  let email = $a.style(
    toList([["color", palette.grey_600], ["font-size", "12px"]]),
  );
  return $l.column(
    toList([$l.gap(0)]),
    toList([]),
    toList([
      $h.div(toList([name]), toList([$h.text(user.name)])),
      $h.div(toList([email]), toList([$h.text(user.email)])),
    ]),
  );
}

function user_picture(user) {
  return $h.div(
    toList([$a.style(toList([["padding-left", "9px"]]))]),
    toList([$pp.from_user(user.picture, user.initials, new $pp.Large())]),
  );
}

function row_checkbox(user_id, selected, set_selected) {
  return $checkbox.checkbox(
    $checkbox.checked($set.contains(selected, user_id)),
    false,
    (checked) => {
      return set_selected(
        (selected) => {
          if (checked) {
            return $set.insert(selected, user_id);
          } else {
            return $set.delete$(selected, user_id);
          }
        },
      );
    },
  );
}

function loading_table() {
  return $table.body(
    (() => {
      let _pipe = $table.row(
        toList([
          $table.cell($skeleton.skeleton(20, 20)),
          $table.cell($skeleton.skeleton(36, 36)),
          $table.cell($skeleton.skeleton(200, 25)),
          $table.cell($skeleton.skeleton(200, 25)),
          $table.cell($skeleton.skeleton(100, 25)),
          $table.cell(
            $l.row(
              toList([$l.gap(4)]),
              toList([]),
              toList([
                $skeleton.skeleton(100, 25),
                $skeleton.skeleton(100, 25),
                $skeleton.skeleton(100, 25),
              ]),
            ),
          ),
        ]),
      );
      return $list.repeat(_pipe, 4);
    })(),
  );
}

function use_remove_roles_click(component, selected, org_id) {
  let effect_dispatch = $store.use_effect_dispatch();
  let modal = $modal.use_modal();
  return ((_capture) => {
    return $redraw.use_callback(_capture, [selected, org_id]);
  })(
    (_) => {
      return $function.tap(
        undefined,
        (_) => {
          let _pipe = modal.open(component);
          return $promise.map(
            _pipe,
            (result) => {
              if (result instanceof Ok) {
                let role_ids = result[0].role_ids;
                let user_ids = $set.to_list(selected);
                effect_dispatch(
                  $user_effects.remove_roles(org_id, user_ids, role_ids),
                );
                return undefined;
              } else {
                return undefined;
              }
            },
          );
        },
      );
    },
  );
}

function use_assign_roles_click(component, selected, org_id) {
  let effect_dispatch = $store.use_effect_dispatch();
  let modal = $modal.use_modal();
  return ((_capture) => {
    return $redraw.use_callback(_capture, [selected, org_id]);
  })(
    (_) => {
      return $function.tap(
        undefined,
        (_) => {
          let _pipe = modal.open(component);
          return $promise.map(
            _pipe,
            (result) => {
              if (result instanceof Ok) {
                let role_ids = result[0].role_ids;
                let user_ids = $set.to_list(selected);
                effect_dispatch(
                  $user_effects.assign_roles(org_id, user_ids, role_ids),
                );
                return undefined;
              } else {
                return undefined;
              }
            },
          );
        },
      );
    },
  );
}

function toggle_role(role_id, set_roles) {
  return set_roles(
    (roles) => {
      let $ = $set.contains(roles, role_id);
      if ($) {
        return $set.delete$(roles, role_id);
      } else {
        return $set.insert(roles, role_id);
      }
    },
  );
}

function remove_roles_modal() {
  return $redraw.component_(
    "RemoveRoles",
    (props) => {
      let store = $store.use_state();
      let $ = $redraw.use_state_($set.new$());
      let chosen_roles = $[0];
      let set_roles = $[1];
      return $when.ok(
        $remote.read(store.roles),
        (roles) => {
          let roles$1 = $list.sort(
            roles,
            (r1, r2) => { return $common.compare_roles(r1.name, r2.name); },
          );
          let submit_disabled = $set.is_empty(chosen_roles);
          let on_close = $e.on_click(
            (_) => { return props.on_end(new Error(undefined)); },
          );
          let on_submit = $e.on_click(
            (_) => {
              return props.on_end(
                new Ok(new RemoveRolesConfirm($set.to_list(chosen_roles))),
              );
            },
          );
          return $modal.modal(
            toList([]),
            toList([
              $modal.body(
                toList([]),
                toList([
                  $modal.title(toList([]), toList([$h.text("Remove roles")])),
                  $modal.explanations(
                    toList([]),
                    toList([
                      $h.text(
                        "Choose the role(s) to remove from the selected user(s).",
                      ),
                    ]),
                  ),
                  $l.row(
                    toList([$l.gap(4), $l.wrap("wrap")]),
                    toList([]),
                    $list.map(
                      roles$1,
                      (role) => {
                        let on_click = (_) => {
                          return toggle_role(role.id, set_roles);
                        };
                        let name = $h.text(role.name);
                        let size = $button.attributes.small();
                        let $1 = $set.contains(chosen_roles, role.id);
                        if ($1) {
                          return $button.primary(
                            toList([$e.on_click(on_click), size]),
                            toList([name]),
                          );
                        } else {
                          return $button.secondary(
                            toList([$e.on_click(on_click), size]),
                            toList([name]),
                          );
                        }
                      },
                    ),
                  ),
                  $l.row(
                    toList([$l.gap(4), $l.justify("end")]),
                    toList([]),
                    toList([
                      $button.secondary(
                        toList([on_close]),
                        toList([$h.text("Cancel")]),
                      ),
                      $button.primary(
                        toList([$a.disabled(submit_disabled), on_submit]),
                        toList([$h.text("Submit")]),
                      ),
                    ]),
                  ),
                ]),
              ),
            ]),
          );
        },
      );
    },
  );
}

function assign_roles_modal() {
  return $redraw.component_(
    "AssignRoles",
    (props) => {
      let store = $store.use_state();
      let $ = $redraw.use_state_($set.new$());
      let chosen_roles = $[0];
      let set_roles = $[1];
      return $when.ok(
        $remote.read(store.roles),
        (roles) => {
          let roles$1 = $list.sort(
            roles,
            (r1, r2) => { return $common.compare_roles(r1.name, r2.name); },
          );
          let submit_disabled = $set.is_empty(chosen_roles);
          let on_close = $e.on_click(
            (_) => { return props.on_end(new Error(undefined)); },
          );
          let on_submit = $e.on_click(
            (_) => {
              return props.on_end(
                new Ok(new AssignRolesConfirm($set.to_list(chosen_roles))),
              );
            },
          );
          return $modal.modal(
            toList([]),
            toList([
              $modal.body(
                toList([]),
                toList([
                  $modal.title(toList([]), toList([$h.text("Assign roles")])),
                  $modal.explanations(
                    toList([]),
                    toList([
                      $h.text(
                        "Choose the role(s) to assign to the selected user(s).",
                      ),
                    ]),
                  ),
                  $l.row(
                    toList([$l.gap(4), $l.wrap("wrap")]),
                    toList([]),
                    $list.map(
                      roles$1,
                      (role) => {
                        let on_click = (_) => {
                          return toggle_role(role.id, set_roles);
                        };
                        let name = $h.text(role.name);
                        let size = $button.attributes.small();
                        let $1 = $set.contains(chosen_roles, role.id);
                        if ($1) {
                          return $button.primary(
                            toList([$e.on_click(on_click), size]),
                            toList([name]),
                          );
                        } else {
                          return $button.secondary(
                            toList([$e.on_click(on_click), size]),
                            toList([name]),
                          );
                        }
                      },
                    ),
                  ),
                  $l.row(
                    toList([$l.gap(4), $l.justify("end")]),
                    toList([]),
                    toList([
                      $button.secondary(
                        toList([on_close]),
                        toList([$h.text("Cancel")]),
                      ),
                      $button.primary(
                        toList([$a.disabled(submit_disabled), on_submit]),
                        toList([$h.text("Submit")]),
                      ),
                    ]),
                  ),
                ]),
              ),
            ]),
          );
        },
      );
    },
  );
}

function bulk_actions() {
  return $redraw.compose(
    assign_roles_modal(),
    (assign_roles_modal) => {
      return $redraw.compose(
        remove_roles_modal(),
        (remove_roles_modal) => {
          return $redraw.component_(
            "BulkActions",
            (props) => {
              return $when.true$(
                !$set.is_empty(props.selected),
                () => {
                  return $when.some(
                    props.org_id,
                    (org_id) => {
                      let count = $set.size(props.selected);
                      let on_assign_click = use_assign_roles_click(
                        assign_roles_modal,
                        props.selected,
                        org_id,
                      );
                      let on_remove_click = use_remove_roles_click(
                        remove_roles_modal,
                        props.selected,
                        org_id,
                      );
                      return $l.row(
                        toList([$l.gap(8), $l.align("center")]),
                        toList([]),
                        toList([
                          $typo.text(
                            $typo.sm,
                            $typo.medium,
                            $int.to_string(count) + " user(s) selected",
                          ),
                          $button.primary(
                            toList([$e.on_click(on_assign_click)]),
                            toList([$h.text("Assign roles")]),
                          ),
                          $button.secondary(
                            toList([$e.on_click(on_remove_click)]),
                            toList([$h.text("Remove roles")]),
                          ),
                        ]),
                      );
                    },
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}

export function view() {
  return $redraw.compose(
    $common.roles(),
    (roles_view) => {
      return $redraw.compose(
        $common.copy_id(),
        (copy_id) => {
          return $redraw.compose(
            bulk_actions(),
            (bulk_actions) => {
              return $redraw.component_(
                "Authentication(ListUsers",
                (_) => {
                  let store = $store.use_state();
                  let $ = $redraw.use_state_($set.new$());
                  let selected = $[0];
                  let set_selected = $[1];
                  let _block;
                  let _pipe = $store.current_organization(store);
                  _block = $option.map(_pipe, (o) => { return o.id; });
                  let org_id = _block;
                  return $l.column(
                    toList([$l.gap(12)]),
                    toList([]),
                    toList([
                      bulk_actions(
                        new BulkActionsProps(selected, set_selected, org_id),
                      ),
                      $table.table(
                        toList([]),
                        toList([
                          $table.headers(
                            toList([
                              (() => {
                                let _pipe$1 = $table.header("");
                                return $table.fit(_pipe$1);
                              })(),
                              (() => {
                                let _pipe$1 = $table.header("");
                                return $table.fit(_pipe$1);
                              })(),
                              (() => {
                                let _pipe$1 = $table.header("Name");
                                return $table.fit(_pipe$1);
                              })(),
                              (() => {
                                let _pipe$1 = $table.header("ID");
                                return $table.clamp(_pipe$1, "250px", 300);
                              })(),
                              (() => {
                                let _pipe$1 = $table.header("Function");
                                return $table.fit(_pipe$1);
                              })(),
                              $table.header("Roles"),
                            ]),
                          ),
                          (() => {
                            let $1 = $store.organization_users(store);
                            if ($1 instanceof $remote.NotLoaded) {
                              return loading_table();
                            } else if ($1 instanceof $remote.Loading) {
                              return loading_table();
                            } else if ($1 instanceof $remote.Errored) {
                              return $table.body(toList([]));
                            } else {
                              let users = $1[0];
                              return $table.body(
                                $list.map(
                                  users,
                                  (user) => {
                                    return $table.row(
                                      toList([
                                        (() => {
                                          let _pipe$1 = $table.cell(
                                            row_checkbox(
                                              user.id,
                                              selected,
                                              set_selected,
                                            ),
                                          );
                                          return $table.stop_cell_propagation(
                                            _pipe$1,
                                          );
                                        })(),
                                        $table.cell(user_picture(user)),
                                        $table.cell(user_name(user)),
                                        $table.cell(
                                          copy_id([$user_id.to_string(user.id)]),
                                        ),
                                        $table.cell(user_function(user)),
                                        $table.cell(
                                          (() => {
                                            let roles = $list.map(
                                              user.roles,
                                              (r) => { return r.name; },
                                            );
                                            return roles_view([roles]);
                                          })(),
                                        ),
                                      ]),
                                    );
                                  },
                                ),
                              );
                            }
                          })(),
                        ]),
                      ),
                    ]),
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}
